import _ from 'underscore'
import { camelize } from '../utils/string'
import utilColors from 'vuetify/es5/util/colors'

const DARK = 'dark'
const LIGHT = 'light'

/**
 * @mixin
 */
export default {
    props: {
        /**
         * Colour of the toolbar.
         */
        toolbarColor: {
            type: String,
            default: 'secondary'
        },
        /**
         * The colour threshold used to define light and dark.
         */
        colorThreshold: {
            type: Number,
            default: 180
        }
    },
    methods: {
        getHexCode (color) {
            const vm = this
            const index = color.indexOf(' ')
            const themeColors = vm.$vuetify.theme
            const name = index !== -1 ? color.substr(0, index) : color

            if (_.has(themeColors, name)) {
                return vm.$vuetify.theme[color]
            }

            if (_.has(utilColors, name)) {
                const modifier = camelize(color.substr(index + 1))
                const utilColor = utilColors[name]

                if (_.has(utilColor, modifier)) {
                    return utilColor[modifier]
                }

                return utilColors[name].base
            }

            // should only reach here if a non-vuetify theme color is provided
            return utilColors.grey.lighten5
        },
        determineColorType (color, threshold) {
            const vm = this
            const hexCode = vm.getHexCode(color)
            const colorThreshold = threshold ? parseInt(threshold) : vm.colorThreshold

            color = +('0x' + hexCode.slice(1).replace(hexCode.length < 5 && /./g, '$&$&'))

            const rgb = {
                red: color >> 16,
                green: color >> 8 & 255,
                blue: color & 255
            }

            // HSP equation from http://alienryderflex.com/hsp.html
            // brightness = sqrt((0.299 * R^2) + (0.587 * G^2) + (0.114 * B^2))
            const hsp = Math.sqrt(
                0.299 * Math.pow(rgb.red, 2) +
                0.587 * Math.pow(rgb.green, 2) +
                0.114 * Math.pow(rgb.blue, 2)
            )

            return hsp > colorThreshold ? LIGHT : DARK
        },
        isColorDark (color, threshold) {
            return this.determineColorType(color, threshold) === DARK
        }
    },
    computed: {
        isToolbarDark () {
            const vm = this
            return vm.isColorDark(vm.toolbarColor)
        }
    }
}
